import React, { createContext, useContext, useState } from 'react';
import { patchRequest, postRequest } from 'services/api';
import { ACTION_TYPES } from 'utils/constants';

// Membuat context untuk loading
const DiscountCreateContext = createContext();

// Provider untuk context loading
export const DiscountCreateProvider = ({ children }) => {
    const [discount, setDiscount] = useState({
        form: {
            name: '',
            type: '',
            value: 0
        },
        data: null,
        loading: false,
        error: null,
        isSubmitting: false,
        mode: ACTION_TYPES.CREATE,
    });

    const createDiscount = async () => {
        setDiscount((prevState) => ({
            ...prevState,
            isSubmitting: true,
        }));

        try {
            const response = await postRequest('/discount', discount.form);
            if (response.success) {
                setDiscount((prevState) => ({
                    ...prevState,
                    data: response.data,
                    error: null,
                    isSubmitting: false,
                }));

                return { success: true, data: response };
            }
        } catch (error) {
            setDiscount((prevState) => ({
                ...prevState,
                error: 'Failed to create discount',
                isSubmitting: false,
            }));

            return { success: false, error: error };
        }
    }

    const updateDiscount = async (id) => {
        setDiscount((prevState) => ({
            ...prevState,
            isSubmitting: true,
        }));

        try {
            const response = await patchRequest(`/discount/${id}`, discount.form);
            if (response.success) {
                setDiscount((prevState) => ({
                    ...prevState,
                    data: response.data,
                    error: null,
                    isSubmitting: false,
                }));

                return { success: true, data: response };
            }
        } catch (error) {
            setDiscount((prevState) => ({
                ...prevState,
                error: 'Failed to update discount',
                isSubmitting: false,
            }));

            return { success: false, error: error };
        }
    };


    return (
        <DiscountCreateContext.Provider value={{ discount, setDiscount, createDiscount, updateDiscount }}>
            {children}
        </DiscountCreateContext.Provider>
    );
};

// Hook untuk mengakses context loading
export const useDiscountCreate = () => {
    const context = useContext(DiscountCreateContext);
    if (!context) {
        throw new Error('useDiscountCreate must be used within a DiscountCreateContext');
    }
    return context;
};